import { Injectable } from '@angular/core';
import {
    FieldDefinition,
    FormDefinition,
    FormElementType,
} from '@wdx/shared/utils';

import { ReactiveFormLayoutAndDefinition } from '../../../../models';

export const ADDRESS_CONTROL_ADDRESS_TYPE = 'addressType';

@Injectable()
export class AddressTypeService {
    public addressTypeSchema!: ReactiveFormLayoutAndDefinition;

    /**
     * This update the definition. The reason this updates the definition is because we are using the options from the parent form.
     * The options from the parent form updates the ManualAddressForm addressType options. This because there is only one manualAddressForm for the tenant but addressType needs to be different for different forms.
     * Because the parent form doesn't speak to the manualAddressForm we are using the parent Address field type options to override the manualAddressForm addressType options.
     *
     * @param {FormDefinition} definition
     * @param {ReactiveFormLayoutAndDefinition} formElement
     */
    public overrideDefinition(
        definition: FormDefinition,
        formElement: ReactiveFormLayoutAndDefinition,
    ): FormDefinition {
        const DEFINITION = { ...definition };
        const OPTIONS = formElement.options;

        const SCHEMA: FieldDefinition[] = [];

        DEFINITION.schema?.forEach((fieldDefinition) => {
            if (fieldDefinition.name === ADDRESS_CONTROL_ADDRESS_TYPE) {
                this.addressTypeSchema = {
                    elementType: FormElementType.Field,
                    ...fieldDefinition,
                    options: OPTIONS,
                };
                SCHEMA.push(this.addressTypeSchema as FieldDefinition);
            } else {
                SCHEMA.push(fieldDefinition);
            }
        });

        return {
            ...DEFINITION,
            schema: SCHEMA,
        } as FormDefinition;
    }
}
